export default {
  blank: () => import("/opt/build/repo/layouts/blank.vue").then(m => m.default || m),
  default: () => import("/opt/build/repo/layouts/default.vue").then(m => m.default || m)
}